export default {
    BarcodeConfiguration: {
        Barcode: 'Barcode',
        Import: 'Import',
        Product: 'Product barcode template',
        Excel: 'Excel Import Product Barcode Rule Description:',
        already: 'If the system already has product barcode information, update the data based on the product barcode, otherwise create a new product barcode information',
        download: 'Import supplier information template, click to download',
        Importing: 'Importing Excel format must have a title, with red titles being mandatory; Please set the columns in Excel to text format, otherwise there may be type conversion errors',
        Supports: 'Supports: CSV, xls, and xlsx formats. The file size for one import cannot exceed 128MB, and the data row cannot exceed 60000 rows. If it exceeds the limit, please import multiple times.',
        Operation: 'Operation in progress, do you want to continue?',
        available: 'Available',
        Unavailable: 'Unavailable',
    },
};
